module.exports = __webpack_public_path__ + "img/13.c4ec5d9d.png";